export default __webpack_public_path__ + "static/media/SHASHIKUMAR.8b9c66e1.JPG";